import { Grid } from "@chakra-ui/react";
import { DataGridItem, HeadingGridItem } from "../../index";
import { RedirectIconButton } from "./index";
import { Card } from "../../../../../components/Card";
import { routes } from "../../../../../config";

function Overview() {
  return <Card><Grid templateColumns="repeat(13, 1fr)" border={"1px solid lightgray"} borderRadius="md">
    <HeadingGridItem colSpan={4} text={"Material Issues"} />
    <HeadingGridItem colSpan={4} text={"Indicators"} />
    <HeadingGridItem colSpan={4} text={"Unit of measurement"} />
    <HeadingGridItem text={"Track"} />

    <DataGridItem colSpan={4} rowSpan={2} fontSize="md" fontWeight="semibold"
                  children={"Policy and regulation change aligned to net zero"} />
    <DataGridItem colSpan={4} children={"Carbon price"} />
    <DataGridItem colSpan={4} children={"Relevant currency e.g. Pounds Sterling (£)"} />
    <DataGridItem
      isText={false}
      justifyContent={"center"}
      children={<RedirectIconButton redirectTo={routes.knowledgeBaseCarbonPrice} />} />
    <DataGridItem colSpan={4} children={"Emission reduction targets"} />
    <DataGridItem colSpan={4}
                  children={"Types of policy e.g. banning petrol/diesel, timeframe and intensity"} />
    <DataGridItem
      isText={false}
      justifyContent={"center"}
      children={<RedirectIconButton redirectTo={routes.knowledgeBaseClimateActionTracker} />} />

    <DataGridItem colSpan={4} rowSpan={2} fontSize="md" fontWeight="semibold"
                  children={"Legal implications of climate change"} />
    <DataGridItem colSpan={4} children={"Exposure to litigation"} />
    <DataGridItem colSpan={4} children={"Number of lawsuits related to climate issues"} />
    <DataGridItem
      isText={false}
      justifyContent={"center"}
      children={<RedirectIconButton redirectTo={routes.knowledgeBaseExposureToLitigation} />} />
    <DataGridItem colSpan={4} children={"High insurance premiums"} />
    <DataGridItem colSpan={4} children={"Cost of insurance policies e.g. D&O"} />
    <DataGridItem children={""} />

    <DataGridItem colSpan={4} fontSize="md" fontWeight="semibold"
                  children={"Sustainable finance & growth strategy"} />
    <DataGridItem colSpan={4} children={"Sustainable Finance Regulation"} />
    <DataGridItem colSpan={4}
                  children={"Quantity of regulations being established e.g. Sustainable Finance Disclosure Regulations (SFDR)"} />
    <DataGridItem
      isText={false}
      justifyContent={"center"}
      children={<RedirectIconButton
        redirectTo={routes.knowledgeBaseSustainableFinanceRegulation} />} />

    <DataGridItem colSpan={4} rowSpan={2} fontSize="md" fontWeight="semibold"
                  children={"Changing customer preferences and attitudes"} />
    <DataGridItem colSpan={4} children={"More locally sourced products"} />
    <DataGridItem colSpan={4}
                  children={"Increased customer engagement regarding sourcing e.g., survey"} />
    <DataGridItem children={""} />
    <DataGridItem colSpan={4} children={"Increased cost and unavailability of raw materials"} />
    <DataGridItem colSpan={4} children={"Price change"} />
    <DataGridItem children={""} />

    <DataGridItem colSpan={4} rowSpan={2} fontSize="md" fontWeight="semibold"
                  children={"Attract and motivate talent"} />
    <DataGridItem colSpan={4} children={"Recruitment levels"} />
    <DataGridItem colSpan={4} children={"Number of new hires"} />
    <DataGridItem children={""} />
    <DataGridItem colSpan={4} children={"Employee retention rates"} />
    <DataGridItem colSpan={4} children={"Employee turnover"} />
    <DataGridItem children={""} />

    <DataGridItem colSpan={4} rowSpan={2} fontSize="md" fontWeight="semibold"
                  children={"Maintaining strong purposeful brand"} />
    <DataGridItem colSpan={4} children={"Market share"} />
    <DataGridItem colSpan={4} children={"% sales of total industry revenue"} />
    <DataGridItem children={""} />
    <DataGridItem colSpan={4} children={"Climate driven investment decisions"} />
    <DataGridItem colSpan={4} children={"Proxy voting on ESG issues"} />
    <DataGridItem children={""} />

    <DataGridItem colSpan={4} rowSpan={3} fontSize="md" fontWeight="semibold"
                  children={"Invention of new decarbonisation technologies"} />
    <DataGridItem colSpan={4} children={"Fossil fuel phase out"} />
    <DataGridItem colSpan={4} children={"Government reduction targets and timeframe"} />
    <DataGridItem children={""} />
    <DataGridItem colSpan={4} children={"Low-carbon technology grants, loands, and subsidies"} />
    <DataGridItem colSpan={4} children={"Availability and applicability"} />
    <DataGridItem children={""} />
    <DataGridItem colSpan={4} children={"Renewable energy consumption"} />
    <DataGridItem colSpan={4} children={"% grid using renewable energy "} />
    <DataGridItem children={""} />
  </Grid>
  </Card>
}

export default Overview;